import React, {useRef} from 'react';
import {Input} from 'reactstrap';
import checkedIcon from './icons/checked.svg';
import Image from '../Image/image';
const TextInputWithButton = (props) => {
  //const inputRefs = useRef({});
  const {isLoading = false, isValidated = false, floatingPlaceHolderEnabled = true} = props;

  const renderButtonContent = () => {
    var buttonText = props.buttonText || 'לבדיקה';
    if (isLoading) {
      return (
        <>
          <span className='button-spinner'></span>
          <span>בדיקה..</span>
        </>
      );
    }
    if (isValidated) {
      return (
        <>
          <Image src={checkedIcon} alt='checked' className='button-check-icon' />
        </>
      );
    }
    return buttonText;
  };

  const getInput = () => {
    return (
      <>
        <Input
          disabled={props.disabled}
          name={props.name}
          className='form-control'
          {...props}
          placeholder={!floatingPlaceHolderEnabled ? props.placeholder : ''}
        />
        <div
          className={`text-input-button ${props.btnDisabled || isLoading ? 'disabled' : ''} ${isLoading ? 'loading' : ''} ${
            isValidated ? 'validated' : ''
          }`}
          onClick={() => !isLoading && props.buttonAction()}>
          {renderButtonContent()}
        </div>
      </>
    );
  };
  const handleButtonAction = () => {
    if (!isLoading && !props.btnDisabled && props.buttonAction) {
      props.buttonAction();
    }
  };
  return (
      <div className='text-input-with-button'>
      {floatingPlaceHolderEnabled ? (
        <label className={`has-float-${props.required ? 'label-required' : 'label'}`}>
          {getInput()}
          <span className={`${props.error ? 'placeholder-error' : ''}`}>{props.placeholder}</span>
        </label>
      ) : (
        getInput()
      )}
      {props.error && <div className='error'>{props.error}</div>}
      {props.result != null && (
        <div className={`check-result ${props.result.accepted ? 'accepted' : 'not-accepted'}`}>{props.result.resultText}</div>
      )}
      {props.fullName && <div>שם מנוי: {props.fullName}</div>}
    </div>
  );
};

export default TextInputWithButton;
